import { UploadFile } from 'antd';
import 'dayjs/locale/fr';

export interface CreateRequestFile {
  name: string;
  type: string;
  content: string;
}

interface FileRequest {
  FileType: string;
  Title: string;
}

export const filesToBase64 = async (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.readAsDataURL(file);
    reader.onerror = reject;
  });
};

export const mapDropzoneFiles = async (
  files: UploadFile[],
): Promise<CreateRequestFile[]> => {
  return Promise.all(
    files.map(async (file) => {
      const [type, content] = (
        await filesToBase64(file.originFileObj as File)
      ).split('base64,');

      return {
        name: file.name ?? '',
        type: type.split(':')[1],
        content,
      };
    }),
  );
};

export function downloadBase64File(infos: FileRequest, base64Data: string) {
  const linkSource = `data:${infos.FileType.toLowerCase()};base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = infos.Title;
  downloadLink.target = '_blank';
  downloadLink.click();
}

export function getValueFromEvent(e: unknown) {
  if (Array.isArray(e)) {
    return e;
  }

  return (e as { fileList?: UploadFile[] } | undefined)?.fileList;
}
